<script lang="ts">
    export let height = "h-6";
    export let width = "w-6";
    export let strokeColor = "stroke-mdark";
    export let fillColor = "fill-mdark";
    export let hover = "group-hover:stroke-mblue group-hover:fill-mblue";
    export let strokeWidth = "0.1";
    export let classList = "aspect-ratio transition-all";
</script>

<svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon {height} {width} {strokeColor} {fillColor} {classList} {hover}"
    stroke-width={strokeWidth}
    stroke-linecap="round"
    stroke-linejoin="round"
    viewBox="0 0 24 24"
>
    <path d="M17.56 17.97H6.44C2.46 17.97 1.25 16.76 1.25 12.78V6.44C1.25 2.46 2.46 1.25 6.44 1.25H12.75C13.16 1.25 13.5 1.59 13.5 2C13.5 2.41 13.16 2.75 12.75 2.75H6.44C3.3 2.75 2.75 3.3 2.75 6.44V12.77C2.75 15.91 3.3 16.46 6.44 16.46H17.55C20.69 16.46 21.24 15.91 21.24 12.77V10.4022C21.24 9.99221 21.58 9.65221 21.99 9.65221C22.4 9.65221 22.74 9.99221 22.74 10.4022V12.77C22.75 16.76 21.54 17.97 17.56 17.97Z" />
    <path d="M12 22.75C11.59 22.75 11.25 22.41 11.25 22V17.22C11.25 16.81 11.59 16.47 12 16.47C12.41 16.47 12.75 16.81 12.75 17.22V22C12.75 22.41 12.41 22.75 12 22.75Z" />
    <path d="M22 13.75H2C1.59 13.75 1.25 13.41 1.25 13C1.25 12.59 1.59 12.25 2 12.25H22C22.41 12.25 22.75 12.59 22.75 13C22.75 13.41 22.41 13.75 22 13.75Z" />
    <path d="M16.5 22.75H7.5C7.09 22.75 6.75 22.41 6.75 22C6.75 21.59 7.09 21.25 7.5 21.25H16.5C16.91 21.25 17.25 21.59 17.25 22C17.25 22.41 16.91 22.75 16.5 22.75Z" />
    <path d="M22.4998 6C22.4998 6.41421 22.164 6.75 21.7498 6.75C21.3356 6.75 20.9998 6.41421 20.9998 6V3.71191L15.7586 8.55078C15.4543 8.83167 14.98 8.81296 14.699 8.50879C14.4181 8.20449 14.4368 7.7302 14.741 7.44922L19.8318 2.75H17.2498C16.8356 2.75 16.4998 2.41421 16.4998 2C16.4998 1.58579 16.8356 1.25 17.2498 1.25H21.7498C22.164 1.25 22.4998 1.58579 22.4998 2V6Z" />
</svg>
